import { useContext } from "react";
import {observer} from "mobx-react";

import classNames from "classnames";
import styles from "./styles/FooterCS.module.scss";
import Markdown from "../utilities/Markdown";

import AllModals from "../modals/_AllModals";
import PoweredBy from './PoweredBy';
import FooterClaimCS from './FooterClaimCS';
import FooterAddressColumn from "./FooterAddressColumn";
import FooterAccountColumn from './FooterAccountColumn';
import FooterNavColumn from './FooterNavColumn';
import FooterSocialColumn from './FooterSocialColumn';
import {StoreContext} from "../../stores/StoreLoader";
import FooterHTML from "./FooterHTML";
import DangerouslySetHtmlContent from "../utilities/DangerouslySetHtmlContent";
import {ErrorBoundary} from "../utilities/ErrorBoundary";

const mainFooterClassName = classNames({
    [styles.mainFooter]: true,
});
const descriptionColumnClassName = classNames({
    [styles.descriptionColumn]: true,
});

const Footer = observer(props => {
    const {organizationStore, userStore, interfaceStore} = useContext(StoreContext);

    let accountColumn;
    if ((interfaceStore.isSchoolBlocks && userStore.id) || userStore.isAdmin) {
        // in cleversite we don't have any account links for non-admins, in schoolblocks we do
        accountColumn = <FooterAccountColumn/>;
    } else {
        let text;

        if (interfaceStore.isSchoolBlocks) {
            text = organizationStore.organization.json_data.settings?.headerText;
        } else {
            text = organizationStore?.blocks.get('about')?.items.find(item => item.published)?.description;
        }
        if (text) {
            accountColumn = <div className={descriptionColumnClassName}>
                <Markdown source={text}/>
            </div>;
        }
    }

    let claimButton;
    if (!organizationStore.organization.is_claimed && !interfaceStore.isSchoolBlocks) {
        claimButton = <FooterClaimCS/>;
    }

    let supportCode;
    if (organizationStore.organization.json_data.settings.support && !(
        organizationStore.organization.json_data.settings.support.authenticatedOnly && userStore.id
    )) {
        supportCode = <ErrorBoundary userGenerated={true}>
            <DangerouslySetHtmlContent html={organizationStore.organization.json_data.settings.support.code}/>
        </ErrorBoundary>
    }

    return (<>
            <footer className={mainFooterClassName}>
                <div className={styles.navContainer}>
                    <FooterAddressColumn/>
                    {accountColumn}
                    <FooterNavColumn/>
                    <FooterSocialColumn/>
                </div>
                <FooterHTML/>
                {claimButton}
                <PoweredBy/>
            </footer>
            <AllModals />
            {supportCode}
        </>
    );
});

export default Footer;
